import React, { useMemo } from "react";
import "../Terms/Terms.css";
import { useLocalContext } from "../../context/LocalContext";

const RefundPolicy = () => {
  const { webinfo = {} } = useLocalContext();

  const brand = useMemo(
    () => ({
      name: webinfo.name || "webantidigi.com",
      email: webinfo.email || "contact@webantidigi.com",
      phone: webinfo.phone || "+1 (000) 000-0000",
      phonecall: webinfo.phonecall || "+10000000000",
      address: webinfo.address || "United States",
    }),
    [webinfo]
  );

  const effectiveDate = useMemo(
    () =>
      new Date().toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      }),
    []
  );

  return (
    <section className="terms">
      <div className="terms-wrap">
        <header className="terms-head">
          <span className="terms-kicker">Legal</span>
          <h1>Refund Policy</h1>
          <p className="terms-meta">
            <span>Provider: {brand.name}</span>
            <span>Last updated: {effectiveDate}</span>
            <span>Applicable to: United States</span>
          </p>
        </header>

        <div className="terms-content">
          <TermsBlock title="1. Policy overview">
            <p>
              This policy explains when refunds may be approved for services and
              digital products. We aim for clear, fair, and non-misleading refund
              conditions.
            </p>
          </TermsBlock>

          <TermsBlock title="2. Possible refund cases">
            <ul>
              <li>Confirmed duplicate payment</li>
              <li>Confirmed delivery failure not resolved by support</li>
              <li>Confirmed fulfillment error from our side</li>
              <li>Any case where applicable law requires a refund</li>
            </ul>
          </TermsBlock>

          <TermsBlock title="3. Typical non-refundable cases">
            <ul>
              <li>Change of mind after completed digital delivery</li>
              <li>Incorrect selection made by customer</li>
              <li>Completed and accepted service milestones</li>
              <li>Third-party fees already incurred on your behalf</li>
            </ul>
          </TermsBlock>

          <TermsBlock title="4. How to request a review">
            <p>
              Send requests to <a href={`mailto:${brand.email}`}>{brand.email}</a>{" "}
              with order reference, payment details, and issue summary. We review
              requests within a reasonable business timeframe.
            </p>
          </TermsBlock>

          <TermsBlock title="5. Processing method">
            <p>
              Approved refunds are generally issued to the original payment method.
              Processing times depend on payment providers.
            </p>
          </TermsBlock>

          <TermsBlock title="6. Contact">
            <ul className="terms-contact">
              <li>
                <strong>Email:</strong>{" "}
                <a href={`mailto:${brand.email}`}>{brand.email}</a>
              </li>
              <li>
                <strong>Phone:</strong>{" "}
                <a href={`tel:${brand.phonecall}`}>{brand.phone}</a>
              </li>
              <li>
                <strong>Address:</strong> {brand.address}
              </li>
            </ul>
          </TermsBlock>
        </div>
      </div>
    </section>
  );
};

const TermsBlock = ({ title, children }) => (
  <section className="terms-card">
    <h2>{title}</h2>
    {children}
  </section>
);

export default RefundPolicy;
